export default __webpack_public_path__ + "static/media/cloth-pointer.d495a911.png";